module.exports = __webpack_public_path__ + "static/media/site_resources_product_info.46b0aa55.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/mi-app/siteResources/assets/site_resources_product_info.jpeg
// module id = 1129
// module chunks = 1